/* TCD collection / search grid — facet form enhancement over a plain GET form.
   Re-renders the grid section through ?section_id= and swaps results, chips, count and pagination.
   Load more appends the next page (+ pushState). Numbered links stay real links. */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const isDesktop = () => desktopQuery.matches;

  function init() {
    const root = $('[data-tcd-colgrid]');
    if (!root) return;
    const form = $('[data-tcd-facets-form]', root);
    const sectionId = root.dataset.sectionId;
    const baseUrl = root.dataset.baseUrl;
    let ctrl = null, debounce = null;

    function skeleton(n) {
      let s = '';
      for (let i = 0; i < n; i++) s += '<li><div class="tcd-skelcard"><div class="tcd-skelcard__media"></div><div class="tcd-skelcard__body"><span style="width:40%"></span><span style="width:90%"></span><span style="width:70%"></span><span style="width:35%"></span></div></div></li>';
      return s;
    }
    function formParams() {
      const fd = new FormData(form);
      const p = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (v !== '' && v !== null) p.append(k, v); }
      return p;
    }
    function urlFor(params) { return baseUrl + (params.toString() ? '?' + params.toString() : ''); }

    async function load(url, opts) {
      opts = opts || {};
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const results = $('[data-tcd-results]', root);
      results.setAttribute('aria-busy', 'true');
      if (!opts.append) { const g = $('[data-tcd-grid]', results); if (g) g.innerHTML = skeleton(8); }
      try {
        const u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
        const r = await fetch(u.toString(), { signal: ctrl.signal });
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-tcd-colgrid]');
        if (!fresh) return;
        if (opts.append) {
          const grid = $('[data-tcd-grid]', results), freshGrid = fresh.querySelector('[data-tcd-grid]');
          if (grid && freshGrid) {
            const seam = document.createElement('li'); seam.className = 'tcd-pagination__seam'; seam.style.gridColumn = '1/-1'; seam.textContent = 'Page ' + freshGrid.dataset.page;
            grid.appendChild(seam);
            Array.from(freshGrid.children).forEach(li => grid.appendChild(li));
            grid.dataset.page = freshGrid.dataset.page;
          }
          const pag = $('[data-tcd-pagination]', results), fp = fresh.querySelector('[data-tcd-pagination]');
          if (pag && fp) { pag.innerHTML = fp.innerHTML; const shown = $('[data-tcd-shown]', pag); if (shown) shown.textContent = String($$('[data-tcd-card]', grid).length); }
          else if (pag) pag.remove();
        } else {
          results.innerHTML = fresh.querySelector('[data-tcd-results]').innerHTML;
          $('[data-tcd-chips]', root).innerHTML = fresh.querySelector('[data-tcd-chips]').innerHTML;
          const tb = $('[data-tcd-toolbar]', root), ftb = fresh.querySelector('[data-tcd-toolbar]');
          if (tb && ftb) { const sortEl = $('[data-tcd-sort]', tb); const keep = sortEl ? sortEl.value : null; tb.innerHTML = ftb.innerHTML; const ns = $('[data-tcd-sort]', tb); if (ns && keep) ns.value = keep; bindToolbar(); }
          const rc = $('[data-tcd-results-count]', document); const frc = fresh.querySelector('[data-tcd-results-count]'); if (rc && frc) rc.textContent = frc.textContent;
          const hc = $('.tcd-colhead__count'); if (hc && frc) hc.textContent = frc.textContent.replace('results', 'products').replace('result', 'product');
          const live = $('[data-tcd-live-count]', root); if (live && frc) live.textContent = frc.textContent.replace(/\D/g, '');
          // facet counts refresh (keep open state)
          const openIds = $$('[data-tcd-facet]', root).filter(d => d.open).map(d => d.dataset.tcdFacet);
          const body = $('.tcd-facetwrap__body', root), fbody = fresh.querySelector('.tcd-facetwrap__body');
          if (body && fbody && !opts.keepFacets) { body.innerHTML = fbody.innerHTML; $$('[data-tcd-facet]', body).forEach(d => { if (openIds.includes(d.dataset.tcdFacet)) d.open = true; }); bindFacets(); }
          loadFallback();
        }
        if (!opts.silent) history.pushState({ tcd: true }, '', url.replace(/([?&])section_id=[^&]*/, '$1').replace(/[?&]$/, ''));
        if (!opts.append && !opts.noScroll && !isDesktop()) { const tb = $('[data-tcd-toolbar]', root); if (tb) window.scrollTo({ top: tb.getBoundingClientRect().top + window.scrollY - 8, behavior: reduced ? 'auto' : 'smooth' }); }
      } catch (e) { if (e.name !== 'AbortError') location.href = url; }
      finally { results.setAttribute('aria-busy', 'false'); }
    }

    function applyForm() {
      const p = formParams();
      const url = urlFor(p);
      if (isDesktop()) load(url); else liveCount(url);
    }
    async function liveCount(url) {
      const live = $('[data-tcd-live-count]', root); if (!live) return;
      try {
        const u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
        const r = await fetch(u.toString()); const html = await r.text();
        const m = html.match(/data-tcd-results-count[^>]*>([^<]*)</); if (m) live.textContent = m[1].replace(/\D/g, '');
      } catch (e) { /* noop */ }
    }
    function bindToolbar() {
      const sort = $('[data-tcd-sort]', root);
      if (sort) sort.addEventListener('change', () => { $('[data-tcd-sort-input]', form).value = sort.value; load(urlFor(formParams())); });
      const rail = $('[data-tcd-rail-toggle]', root);
      if (rail) rail.addEventListener('click', () => {
        const collapsed = root.classList.toggle('tcd-colgrid--rail-collapsed');
        rail.setAttribute('aria-pressed', collapsed ? 'false' : 'true');
        $('[data-tcd-rail-label]', rail).textContent = collapsed ? 'Show filters' : 'Hide filters';
        try { sessionStorage.setItem('tcd_rail', collapsed ? 'collapsed' : 'open'); } catch (e) { /* noop */ }
      });
    }
    function bindFacets() {
      $$('[data-tcd-facet-search]', root).forEach(inp => inp.addEventListener('input', () => {
        const q = inp.value.trim().toLowerCase();
        const list = inp.closest('.tcd-acc__body').querySelector('[data-tcd-facet-values]');
        $$('.tcd-facet__value', list).forEach(li => { li.hidden = q ? !li.dataset.label.includes(q) : li.classList.contains('is-overflow'); });
      }));
      $$('[data-tcd-facet-more]', root).forEach(b => b.addEventListener('click', () => { $$('.tcd-facet__value.is-overflow', b.parentElement).forEach(li => { li.hidden = false; li.classList.remove('is-overflow'); }); b.hidden = true; }));
      // price: inc-VAT display inputs + slider → real ex-VAT params
      $$('[data-tcd-price]', root).forEach(box => {
        const mult = parseFloat(box.dataset.mult) || 1.2, max = parseFloat(box.dataset.max) || 0;
        const inc = { min: $('[data-tcd-price-inc="min"]', box), max: $('[data-tcd-price-inc="max"]', box) };
        const real = { min: $('[data-tcd-price-real="min"]', box), max: $('[data-tcd-price-real="max"]', box) };
        const rng = { min: $('[data-tcd-price-range="min"]', box), max: $('[data-tcd-price-range="max"]', box) };
        const ex = { min: $('[data-tcd-price-ex="min"]', box), max: $('[data-tcd-price-ex="max"]', box) };
        const fill = $('[data-tcd-price-fill]', box);
        function paint() {
          const lo = inc.min.value === '' ? 0 : Number(inc.min.value), hi = inc.max.value === '' ? max : Number(inc.max.value);
          if (rng.min) rng.min.value = lo; if (rng.max) rng.max.value = hi;
          if (fill && max > 0) { fill.style.left = (Math.min(lo, hi) / max * 100) + '%'; fill.style.right = (100 - Math.max(lo, hi) / max * 100) + '%'; }
          ex.min.textContent = inc.min.value === '' ? '' : '£' + (lo / mult).toFixed(2) + ' ex VAT';
          ex.max.textContent = inc.max.value === '' ? '' : '£' + (hi / mult).toFixed(2) + ' ex VAT';
        }
        function commit() {
          real.min.value = inc.min.value === '' ? '' : (Number(inc.min.value) / mult).toFixed(2);
          real.max.value = inc.max.value === '' ? '' : (Number(inc.max.value) / mult).toFixed(2);
          paint(); clearTimeout(debounce); debounce = setTimeout(applyForm, 350);
        }
        inc.min.addEventListener('change', commit); inc.max.addEventListener('change', commit);
        if (rng.min) rng.min.addEventListener('input', () => { inc.min.value = Math.min(Number(rng.min.value), Number(rng.max.value)); paint(); });
        if (rng.max) rng.max.addEventListener('input', () => { inc.max.value = Math.max(Number(rng.min.value), Number(rng.max.value)); paint(); });
        if (rng.min) rng.min.addEventListener('change', commit); if (rng.max) rng.max.addEventListener('change', commit);
        paint();
      });
      $$('[data-tcd-facet-input]', root).forEach(inp => { if (inp.type === 'checkbox') inp.addEventListener('change', () => { clearTimeout(debounce); debounce = setTimeout(applyForm, 120); }); });
    }
    function loadFallback() {
      const fb = $('[data-tcd-empty-fallback]', root); if (!fb) return;
      fetch(fb.dataset.url).then(r => r.text()).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = Array.from(doc.querySelectorAll('[data-tcd-grid] > li')).slice(0, 4);
        if (cards.length) { const g = $('[data-tcd-fallback-grid]', fb); cards.forEach(c => g.appendChild(c)); } else fb.hidden = true;
      }).catch(() => { fb.hidden = true; });
    }
    // chips / clear / numbered links inside the section → ajax
    root.addEventListener('click', (e) => {
      const a = e.target.closest('[data-tcd-facet-link]');
      if (a) { e.preventDefault(); load(a.getAttribute('href')); closeDrawer(); return; }
      const more = e.target.closest('[data-tcd-load-more]');
      if (more) { e.preventDefault(); more.setAttribute('aria-busy', 'true'); load(more.getAttribute('href'), { append: true }); return; }
      const pg = e.target.closest('.tcd-pagination__pages a');
      if (pg) { e.preventDefault(); load(pg.getAttribute('href')); window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 80, behavior: reduced ? 'auto' : 'smooth' }); }
    });
    // brand row chips live outside the section
    document.addEventListener('click', (e) => { const a = e.target.closest('.tcd-colbrands [data-tcd-facet-link]'); if (a) { e.preventDefault(); load(a.getAttribute('href')); } });
    form.addEventListener('submit', (e) => { e.preventDefault(); load(urlFor(formParams()), { noScroll: false }); closeDrawer(); });
    // mobile drawer
    const drawer = $('[data-tcd-facet-drawer]', root), panel = $('[data-tcd-facet-panel]', root);
    let opener = null;
    function openDrawer(by) { if (isDesktop()) return; opener = by; drawer.classList.add('is-open'); document.body.classList.add('tcd-facets-open'); setTimeout(() => panel.focus(), 30); }
    function closeDrawer() { if (!drawer.classList.contains('is-open') && location.hash !== '#filters') return; drawer.classList.remove('is-open'); document.body.classList.remove('tcd-facets-open'); if (location.hash === '#filters') history.replaceState(null, '', location.pathname + location.search); if (opener) opener.focus(); }
    $$('[data-tcd-facets-open]', root).forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(b); }));
    drawer.addEventListener('click', (e) => { if (e.target.closest('[data-tcd-facets-close]')) { e.preventDefault(); closeDrawer(); } });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
    if (location.hash === '#filters') {
      if (isDesktop()) {
        document.body.classList.remove('tcd-facets-open');
        drawer.classList.remove('is-open');
        history.replaceState(null, '', location.pathname + location.search);
        requestAnimationFrame(() => window.scrollTo({ top: Math.max(0, root.getBoundingClientRect().top + window.scrollY - 150), behavior: 'auto' }));
      } else {
        openDrawer();
      }
    }
    const onViewportChange = (event) => { if (event.matches) closeDrawer(); };
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onViewportChange);
    else if (desktopQuery.addListener) desktopQuery.addListener(onViewportChange);
    // rail state
    try { if (sessionStorage.getItem('tcd_rail') === 'collapsed') { root.classList.add('tcd-colgrid--rail-collapsed'); const r = $('[data-tcd-rail-toggle]', root); if (r) { r.setAttribute('aria-pressed', 'false'); $('[data-tcd-rail-label]', r).textContent = 'Show filters'; } } else if (sessionStorage.getItem('tcd_rail') === 'open') { root.classList.remove('tcd-colgrid--rail-collapsed'); } } catch (e) { /* noop */ }
    window.addEventListener('popstate', () => { load(location.href, { silent: true, noScroll: true }); });
    bindToolbar(); bindFacets(); loadFallback();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
